export const PAGES = ["home", "products", "contact"];
